import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import Button from 'common/Button';

const styles = (theme) => ({
  button: {
    '&:hover': {
      textDecoration: 'underline',
    },
    clear: 'both',
    color: theme.links.link.color,
    cursor: 'pointer',
    display: 'block',
    fontFamily: theme.actions.callToAction.fontFamily,
    fontSize: theme.actions.callToAction.fontSize,
    margin: '15px auto',
    padding: '2px 10px',
  },
  h2: {
    margin: [theme.spacing.sm, 0, theme.spacing.xs, 0],
  },
  productDisplayGroup: {},
});

export const HomeProductDisplayGroup = ({ classes }) => {
  const productDisplayGroup = useSelector((state) => state.data.productDisplayGroup);
  const market = useSelector((state) => state.refs.market);
  const marketIdentifier = useSelector((state) => state.session.meta?.configs?.marketIdentifier);

  return (
    <div className={classnames('productDisplayGroup', classes.productDisplayGroup)}>
      {productDisplayGroup?.map((group) => (
        <div key={group.name}>
          <h2 className={classes.h2}>{group.label}</h2>
          {group.products?.map((product) => (
            <Button
              type="button"
              key={product.id}
              variant="secondary"
              className={classes.button}
              onClick={(e) => {
                e.preventDefault();
                const url = new URL(`${window.location.origin}/oao`);
                if (product) url.searchParams.append('product', product.name);
                if (market) url.searchParams.append(marketIdentifier, market);
                window.location.assign(url.href);
              }}
            >
              {product.label}
            </Button>
          ))}
        </div>
      ))}
    </div>
  );
};

HomeProductDisplayGroup.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

const HomeProductDisplayGroupStyled = withStyles(styles)(HomeProductDisplayGroup);

export default HomeProductDisplayGroupStyled;
